<template>
  <div>
    <h2 class="m-2">
      CIERRE GESTORES
    </h2>

    <v-card class="mb-5">
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" sm="6" md="3">
            <v-text-field v-model="filters.fecha" label="Fecha" type="date" outlined dense hide-details
              clearable></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select v-model="filters.driver" :items="driverOptions" label="Driver" outlined dense hide-details
              clearable></v-select>
          </v-col>
          <v-col cols="12" sm="6" md="6" class="d-flex align-center justify-end">
            <div class="text-right">
              <span class="text-subtitle-1 grey--text text--darken-1">Total Sumatoria General:</span>
              <h3 class="headline primary--text font-weight-black">
                C$ {{ totalSumColumnAmount.toFixed(2) }}
              </h3>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card>
      <v-data-table :headers="headers" :items="groupedItems" :items-per-page="10" :loading="loading"
        class="elevation-1">
        <template #[`item.fecha`]="{ item }">
          {{ item.fecha }}
        </template>
        <template #[`item.cantEnvios`]="{ item }">
          <v-chip small color="#7367f0" dark class="font-weight-bold px-4" style="cursor: pointer"
            @click="openOrdersModal(item)">
            {{ item.cantEnvios }}
          </v-chip>
        </template>
        <template #[`item.total`]="{ item }">
          C$ {{ item.total.toFixed(2) }}
        </template>
        <template #[`item.pagados`]="{ item }">
          C$ {{ item.pagados.toFixed(2) }}
        </template>
        <template #[`item.pendientes`]="{ item }">
          C$ {{ item.pendientes.toFixed(2) }}
        </template>
        <template #[`item.factura`]="{ item }">
          C$ {{ item.factura.toFixed(2) }}
        </template>
        <template #[`item.totalDepo`]="{ item }">
          C$ {{ item.totalDepo.toFixed(2) }}
        </template>
        <template #[`item.planilla`]="{ item }">
          C$ {{ item.planilla.toFixed(2) }}
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal de Ordenes -->
    <v-dialog v-model="ordersModal.visible" max-width="1200px">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Órdenes - {{ ordersModal.driver }} ({{ ordersModal.fecha }})
          <v-spacer></v-spacer>
          <v-btn icon @click="ordersModal.visible = false">
            <v-icon>{{ icons.mdiClose }}</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4">
          <v-data-table :headers="modalHeaders" :items="ordersModal.items" :items-per-page="5" class="elevation-1">
            <template #[`item.total`]="{ item }">
              C$ {{ item.total ? Number(item.total).toFixed(2) : '0.00' }}
            </template>
            <template #[`item.estado`]="{ item }">
              <v-chip small :color="getStatusColor(resolveStatus(item.estado))" dark>
                {{ resolveStatus(item.estado) }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="ordersModal.visible = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  data() {
    return {
      icons: {
        mdiClose,
      },
      loading: false,
      filters: {
        fecha: null,
        driver: null,
      },
      headers: [
        { text: 'Fecha', value: 'fecha' },
        { text: 'Nombre Driver', value: 'nombreDriver' },
        { text: 'Cant. Envíos', value: 'cantEnvios' },
        { text: 'Sumatoria Total', value: 'total' },
        { text: 'Pagados', value: 'pagados' },
        { text: 'Pendientes a cobrar', value: 'pendientes' },
        { text: 'Factura', value: 'factura' },
        { text: 'Total Depo', value: 'totalDepo' },
        { text: 'Planilla', value: 'planilla' },
      ],
      modalHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Comercio', value: 'nombreCliente' },
        { text: 'Punto A', value: 'puntoA' },
        { text: 'Punto B', value: 'puntoB' },
        { text: 'Flete', value: 'total' },
        { text: 'Estatus', value: 'estado' },
      ],
      items: [],
      ordersModal: {
        visible: false,
        items: [],
        driver: '',
        fecha: '',
      },
    }
  },
  computed: {
    driverOptions() {
      const drivers = this.items.map(item => item.nombreDriver).filter(Boolean)

      return [...new Set(drivers)]
    },
    groupedItems() {
      const groups = {}

      this.items.filter(item => Number(item.estado) === 99).forEach(item => {
        const date = item.fecha_orden ? this.$moment(item.fecha_orden).utc().format('DD-MM-YYYY') : 'N/A'
        const driver = item.nombreDriver || 'Sin Driver'
        const key = `${date}_${driver}`

        if (!groups[key]) {
          groups[key] = {
            fecha: date,
            nombreDriver: driver,
            cantEnvios: 0,
            total: 0,
            pagados: 0,
            pendientes: 0,
            factura: 0,
            totalDepo: 0,
            planilla: 0,
            rawDate: item.fecha_orden ? this.$moment(item.fecha_orden).utc().format('YYYY-MM-DD') : '',
            orders: [],
          }
        }

        groups[key].orders.push(item)

        groups[key].cantEnvios += 1
        groups[key].total += Number(item.total) || 0
        groups[key].factura += Number(item.total_facturas) || 0
        groups[key].totalDepo += Number(item.deposito) || 0
        groups[key].planilla += Number(item.total_neto) || 0

        if (item.estado_pago_envio === 'Pagado') {
          groups[key].pagados += Number(item.total) || 0
        } else if (item.estado_pago_envio === 'Pendiente de cobrar') {
          groups[key].pendientes += Number(item.total) || 0
        }
      })

      return Object.values(groups).filter(group => (!this.filters.fecha || group.rawDate === this.filters.fecha)
        && (!this.filters.driver || group.nombreDriver === this.filters.driver))
    },
    totalSumColumnAmount() {
      return this.groupedItems.reduce((acc, item) => acc + item.total, 0)
    },
  },
  async mounted() {
    await this.getData()
  },
  methods: {
    async getData() {
      try {
        this.loading = true
        const res = await this.$store.dispatch('get', { path: 'ordenes/getAllFull/' })
        if (res && res.length > 0) {
          this.items = res.map(item => ({
            ...item,
            puntoA: item.puntos_mapa?.find(p => p.nombre === 'A')?.direccion || 'N/A',
            puntoB: item.puntos_mapa?.find(p => p.nombre === 'B')?.direccion || 'N/A',
          }))
        }
        this.loading = false
      } catch (error) {
        this.loading = false
        console.error('Error fetching orders', error)
      }
    },
    openOrdersModal(group) {
      this.ordersModal.items = group.orders
      this.ordersModal.driver = group.nombreDriver
      this.ordersModal.fecha = group.fecha
      this.ordersModal.visible = true
    },
    resolveStatus(estado) {
      const e = Number(estado)
      if (e === 0) return 'En espera'
      if (e > 0 && e < 99) return 'En proceso'
      if (e === 99) return 'Finalizada'
      if (e === -99) return 'Anulada'

      return 'N/A'
    },
    getStatusColor(status) {
      switch (status) {
        case 'Finalizada': return 'success'
        case 'En proceso': return 'info'
        case 'Anulada': return 'error'
        case 'En espera': return 'warning'
        default: return 'grey'
      }
    },
  },
}
</script>

<style scoped>
.m-2 {
  margin: 1rem !important;
}

.mb-5 {
  margin-bottom: 2rem !important;
}
</style>
